

export default function inViewport(_ref) {
  var top = _ref.top,
      right = _ref.right,
      bottom = _ref.bottom,
      left = _ref.left;

  var docEl = document.documentElement;

  return top >= 0 && left >= 0 && bottom <= (window.innerHeight || docEl && docEl.clientHeight || 0) && right <= (window.innerWidth || docEl && docEl.clientWidth || 0);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/tooltip/dist/esm/components/utils/inViewport.js
// module id = 300
// module chunks = 0